import type { Tier } from '@/hooks/use-pricing';

export function formatUSD(value: number): string {
  return `$${value.toFixed(2).replace('.', ',')}`;
}

export function tierRange(tier: Tier): string {
  return tier.max === null ? `${tier.min}+` : `${tier.min}–${tier.max}`;
}

export function dailyEarningsRange(tier: Tier): string {
  const minEur = tier.min * tier.price_per_lead;
  if (tier.max === null) return `desde ${formatUSD(minEur)}`;
  const maxEur = tier.max * tier.price_per_lead;
  return `${formatUSD(minEur)} – ${formatUSD(maxEur)}`;
}
